//local storage keys
export const LOCALSTORAGE_KEY = {
  SOURCE_CITY: "KEY_SOURCE_CITY",
  DESTINATION_CITY: "KEY_DESTINATION_CITY",
  DOJ: "KEY_DOJ",
  EMAIL: "EMAIL",
  MOBILE: "MOBILE"
};

export const FILTERS = {
  SORT: "SORT",
  SORT_DEPARTURE: "SORT_DEPARTURE",
  SORT_DURATION: "SORT_DURATION",
  SORT_FARE: "SORT_FARE",

  FILTER_BUS_TYPE: "FILTER_BUS_TYPE",
  FILTER_DEPART_TIME: "FILTER_DEPART_TIME",
  FILTER_ARRIVAL_TIME: "FILTER_ARRIVAL_TIME",
  FILTER_BOARDING: "FILTER_BOARDING",
  FILTER_DROPPING: "FILTER_DROPPING",

  RESET_FILTER: "RESET_FILTER",
  AC: "AC",
  SLEEPER: "SLEEPER",
  SEMI_SLEEPER: "SEMI_SLEEPER",
  MULTI_AXLE: "MULTI_AXLE",
  BEFORE6AM: "BEFORE6AM",
  AFTER6PM: "AFTER6PM",
  BETWEEN_6AM_12PM: "BETWEEN_6AM_12PM",
  BETWEEN_12PM_6PM: "BETWEEN_12PM_6PM"
};
